import { render, staticRenderFns } from "./callPopup.vue?vue&type=template&id=39912a5d&scoped=true&"
import script from "./callPopup.vue?vue&type=script&lang=js&"
export * from "./callPopup.vue?vue&type=script&lang=js&"
import style0 from "./callPopup.vue?vue&type=style&index=0&id=39912a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39912a5d",
  null
  
)

export default component.exports